import { useState, useRef, SyntheticEvent } from 'react';

import useOnIntersect from 'js/hooks/use-on-intersect';

import ContentContainer from 'components/content-container/ContentContainer';

import { IResponsiveIframe } from 'source/NFR.types';

const ResponsiveIframe: React.FC<IResponsiveIframe> = ({ src, title }) => {
  const [height, setHeight] = useState<number>(700);
  const [srcState, setSrcState] = useState<string | undefined>(undefined);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useOnIntersect(iframeRef, () => setSrcState(src));

  const getHeight = (event: SyntheticEvent<HTMLIFrameElement>): void => {
    const iframe = event.currentTarget;
    const newHeight = iframe.contentWindow?.document.body.scrollHeight;
    if (newHeight) {
      setHeight(newHeight);
    }
  };

  return (
    <ContentContainer className="responsive-iframe">
      <iframe
        className="responsive-iframe--iframe"
        onLoad={getHeight}
        src={srcState}
        title={title}
        height={`${height}px`}
        ref={iframeRef}
      />
    </ContentContainer>
  );
};

ResponsiveIframe.displayName = 'ResponsiveIframe';

export default ResponsiveIframe;
